<template>
  <div>
    <div class="info-container mb-10 form-container mx-auto">
        <h5 class="text-lg">{{ $trans.get("registration.personal-title") }}</h5>
    </div>
    <div class="form-container mx-auto">
      <div class="form-container__inputs">
        <!-- PERSONAL DATA -->
       <!-- PERSONAL DATA -->
        <div class="grid md:grid-cols-2 gap-4 mt-5">
          <div class="md:col-span-2">
            <floating-input
              :name="form.personal.basic.name.name"
              :placeholder="$trans.get('registration.' + form.personal.basic.name.name)"
              :initialValue="form.personal.basic.name.value"
              @handle-change="handlePersonalBasic"
              type="text"
              required
              @input.native="removeError($event)"
            ></floating-input>
          </div>
          <floating-input
            :name="form.personal.basic.email.name"
            :placeholder="$trans.get('registration.' + form.personal.basic.email.name)"
            :initialValue="form.personal.basic.email.value"
            @handle-change="handlePersonalBasic"
            type="text"
            required
            @input.native="removeError($event)"
          ></floating-input>
          <floating-input
            :name="form.personal.basic.phone.name"
            :placeholder="$trans.get('registration.' + form.personal.basic.phone.name)"
            :initialValue="form.personal.basic.phone.value"
            @handle-change="handlePersonalBasic"
            type="text"
            required
            @input.native="removeError($event)"
          ></floating-input>
        </div>

        <!-- TYPE ID -->
        <p class="mt-5 mb-3 text-sm">{{ $trans.get('registration.type-id-title-required') }}</p>
        <div class="flex flex-col sm:flex-row justify-center items-center gap-4">
          <floating-select-input
            name="typeId"
            class="sm:w-1/4 w-full"
            :initialValue="form.personal.typeId.value"
            :options="[
              { label: 'DNI', value: 'dni' },
              { label: 'NIE', value: 'nie' },
              { label: $trans.get('registration.passport'), value: 'passport' }
            ]"
            @handle-change="handlePersonal"
            :required="true"
          />

          <floating-input
            name="numId"
            class="w-full"
            :placeholder="$trans.get('registration.numId')"
            @handle-change="handlePersonal"
            :initialValue="form.personal.numId.value"
            type="text"
            required
            @input.native="removeError($event)"
          >
          </floating-input>
        </div>
        <!-------------------->
        <!-- ID FILES -->
        <div class="w-full">
          <p class="mt-6 mb-3 text-sm">{{ $trans.get('registration.idFiles') }}</p>
          <label class="addFile addFilePersonal text-sm" for="idFiles"
            v-if="form.personal.idFiles.display || form.personal.idFiles.value.length > 0"
          v-html="placeholderFileText" 
          ></label>
          <input
          name="idFiles"
          @change="addFiles"
          :initialValue="form.personal.idFiles.value"
          class="hidden"
          type="file"
          id="idFiles"
          required
          />
          <!-- ID FILES PROGRESS -->
          <!-- Recorremos el valor de idFiles para printar por pantalla tantos ProgressFileUpload como documentos haya. -->
          <div v-for="(val, index) in form.personal.idFiles.value" :key="val.id">
            <progress-file-upload
              name="idFiles"
              :index=index
              v-on:click="delFiles"
              :initialValue="form.personal.idFiles"
              v-if="!form.personal.idFiles.display"
            ></progress-file-upload>
          </div>
          <!-- Already loaded files -->
          <ul class="list-disc list-inside mt-4">
            <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                v-if="form.personal.idFilesF.value !== '0' && form.personal.idFiles.display">
              {{ form.personal.idFilesF.value }}
              <button @click="deleteFile('idFilesF')" class="ml-2">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
              </button>
            </li>
            <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                v-if="form.personal.idFilesB.value !== '0' && form.personal.idFiles.display">
              {{ form.personal.idFilesB.value }}
              <button @click="deleteFile('idFilesB')" class="ml-2">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
              </button>
            </li>
          </ul>
        </div>

        <p class="mt-5 mb-3 text-sm">{{ $trans.get('registration.sex') }}</p>
        <div class="mb-4">
          <floating-select-input
           type="select"
            name="gender"
            :placeholder="$trans.get('registration.select')"
            :initialValue="form.personal.gender.value"
            :options="[
              { label: 'Selecciona', value: 'Selecciona' },
              { label: $trans.get('registration.male'), value: 'Hombre' },
              { label: $trans.get('registration.female'), value: 'Mujer' },
              { label: $trans.get('registration.other'), value: 'Otro' }
            ]"
            @handle-change="handlePersonal"
            required
            @input.native="removeError($event)"
          />
        </div>
        <!------------>
        <div class="grid md:grid-cols-2 gap-4 mt-4">
          <floating-input
            v-for="(item, index) in form.personal.extra"
            :key="index"
            :name="item.name"
            :placeholder="$trans.get('registration.' + item.name)"
            :initialValue="item.value"
            @handle-change="handlePersonalExtra"
            type="text"
            :required="item.name !== 'healthCard'" 
            @input.native="removeError($event)"

          >
          </floating-input>
          <floating-input
            name="socialNum"
            :placeholder="$trans.get('registration.socialNum')"
            @handle-change="handlePersonal"
            :initialValue="form.personal.socialNum.value"
            type="text"
          >
          </floating-input>
        </div>
        <!-- Dades Naixement -->
        <div class="grid gap-4 mt-6">
            <p class="text-sm">{{$trans.get('registration.born-data')}}</p>
            <floating-input
            name="foreignCity"
            :placeholder="$trans.get('registration.address.city')"
            @handle-change="handlePersonal"
            :initialValue="form.personal.foreignCity.value"
            type="text"
            required
            @input.native="removeError($event)"
          >
        </floating-input>
            <floating-input
            name="foreignProvince"
            :placeholder="$trans.get('registration.address.province')"
            @handle-change="handlePersonal"
            :initialValue="form.personal.foreignProvince.value"
            type="text"
            required
            @input.native="removeError($event)"
          >
        </floating-input>
            <floating-input
            name="foreignCountry"
            :placeholder="$trans.get('registration.address.country')"
            @handle-change="handlePersonal"
            :initialValue="form.personal.foreignCountry.value"
            type="text"
            required
            @input.native="removeError($event)"
          >
          </floating-input>
        </div>
        <!-- HEALTH CARD FILES -->
        <div>
          <p class="my-6 mb-3 text-sm">{{ $trans.get('registration.healthCardFiles') }}</p>
          <label class="addFile addFilePersonal text-sm" for="healthCardFiles"
            v-if="form.personal.healthCardFiles.display || form.personal.healthCardFiles.value.length > 0"
          v-html="placeholderFileText"></label>
          <input
          name="healthCardFiles"
          @change="addFiles"
          :initialValue="form.personal.healthCardFiles.value"
          class="hidden"
          type="file"
          id="healthCardFiles"
          />
          <!-------------------->
          <!-- HEALTH CARD FILES PROGRESS -->
          <!-- Recorremos el valor de healthCardFiles para printar por pantalla tantos ProgressFileUpload como documentos haya. -->
          <div v-for="(val, index) in form.personal.healthCardFiles.value" :key="val.id">
            <progress-file-upload
              name="healthCardFiles"
              :index=index
              v-on:click="delFiles"
              :initialValue="form.personal.healthCardFiles"
              v-if="!form.personal.healthCardFiles.display"
            ></progress-file-upload>
          </div>
          <!-- Already loaded files -->
          <ul class="list-disc list-inside mt-4">
            <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                v-if="form.personal.healthCardFilesF.value !== '0' && form.personal.healthCardFiles.display">
              {{ form.personal.healthCardFilesF.value }}
              <button @click="deleteFile('healthCardFilesF')" class="ml-2">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
              </button>
            </li>
            <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                v-if="form.personal.healthCardFilesB.value !== '0' && form.personal.healthCardFiles.display">
              {{ form.personal.healthCardFilesB.value }}
              <button @click="deleteFile('healthCardFilesB')" class="ml-2 ">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
              </button>
            </li>
          </ul>


        </div>
        <!-- PHOTO CARD FILES -->
        <div class="">
          <p class="my-6 mb-3 text-sm">{{ $trans.get('registration.photoCardFile') }}</p>
          <label class="addFile addFilePersonal text-sm" for="photoCardFile"
            v-if="form.personal.photoCardFile.display || form.personal.photoCardFile.value.length > 0"
          v-html="placeholderFileText"></label>
          <input
          name="photoCardFile"
          @change="addFiles"
          :initialValue="form.personal.photoCardFile.value"
          class="hidden"
          type="file"
          id="photoCardFile"
          required
          />
          <!-- PHOTO CARD FILES PROGRESS -->
          <!-- Recorremos el valor de photoCardFile para printar por pantalla tantos ProgressFileUpload como documentos haya. -->
          <div v-for="(val, index) in form.personal.photoCardFile.value" :key="val.id">
            <progress-file-upload
              name="photoCardFile"
              :index=index
              v-on:click="delFiles"
              :initialValue="form.personal.photoCardFile"
              v-if="!form.personal.photoCardFile.display"
            ></progress-file-upload>
          </div>
          <!-- Already loaded files -->
          <ul class="list-disc list-inside mt-4">
            <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                v-if="form.personal.photoCardFile.value !== '0' && form.personal.photoCardFile.display">
              {{ form.personal.photoCardFile.value }}
              <button @click="deleteFile('photoCardFile')" class="ml-2">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
              </button>
            </li>
          </ul>
        </div>
        <p class="mt-5 mb-3 text-sm">Idioma habitual</p>
          <div class="mb-4">
            <floating-select-input
              name="language"
              :placeholder="$trans.get('registration.select')"
              :initialValue="form.personal.language.value"
              :options="[
                { label: $trans.get('registration.spanish'), value: 'es' },
                { label: $trans.get('registration.catalan'), value: 'ca' },
                { label: $trans.get('registration.other'), value: 'others' }
              ]"
              @handle-change="handlePersonal"
              required
              @input.native="removeError($event)"
            />
          </div>
        <div class="grid md:grid-cols-2 gap-4">
          <floating-radio-button
            class="mt-4"
            name="scholarship"
            :title="$trans.get('registration.schoolarship')"
            :initialValue="form.personal.scholarship.value"
            :options="[
              {
                label: 'Sí',
                value: 'si',
              },
              {
                label: 'No',
                value: 'no',
              },
            ]"
            required
            @input.native="removeError($event)"
            @handle-change="handlePersonal"
          ></floating-radio-button>
        </div>
        <floating-radio-button
          class="mt-6"
          name="allergy"
          :title="$trans.get('registration.allergy')"
          :initialValue="form.personal.allergy.value"
          :options="[
            {
              label: 'Sí',
              value: 'si',
            },
            {
              label: 'No',
              value: 'no',
            },
          ]"
          @handle-change="handlePersonal"
          required
          @input.native="removeError($event)"
        ></floating-radio-button>
        <div v-if="form.personal.allergy.value === 'si'">
          <floating-textarea
            name="allergyText"
            :placeholder="$trans.get('registration.commentWhichOnes')"
            :initialValue="form.personal.allergyText.value"
            v-model="form.personal.allergyText.value"
          >
          </floating-textarea>
        </div>

     <!-- Contacto de emergencia -->
      <p class="mt-6 mb-3 text-sm">{{ $trans.get('registration.emergency-contact') }}</p>
      <div class="grid md:grid-cols-2 gap-4">
        <div class="md:col-span-2">
          <floating-input
            :name="form.personal.emergencyContact.name.name"
            :placeholder="$trans.get('registration.' + form.personal.emergencyContact.name.name)"
            :initialValue="form.personal.emergencyContact.name.value"
            @handle-change="handlePersonalEmergencyContact"
            type="text"
            required
            @input.native="removeError($event)"
          ></floating-input>
        </div>
        <floating-input
          :name="form.personal.emergencyContact.email.name"
          :placeholder="$trans.get('registration.' + form.personal.emergencyContact.email.name)"
          :initialValue="form.personal.emergencyContact.email.value"
          @handle-change="handlePersonalEmergencyContact"
          type="email"
          required
          @input.native="removeError($event)"
        ></floating-input>
        <floating-input
          :name="form.personal.emergencyContact.phone.name"
          :placeholder="$trans.get('registration.' + form.personal.emergencyContact.phone.name)"
          :initialValue="form.personal.emergencyContact.phone.value"
          @handle-change="handlePersonalEmergencyContact"
          type="text"
          required
          @input.native="removeError($event)"
        ></floating-input>
      </div>




        <div v-show="showTutorsSection" class="info-container mt-12">
          <p class="font-bold text-lg">{{ $trans.get("registration.tutors") }}</p>
          <div class="form-container__inputs mt-6">
          <!-- Pregunta si el tutor legal es el mismo contacto de emergencia -->
          <floating-radio-button
            class="my-6"
            name="emergencyContactSameAsTutor"
            :title="$trans.get('registration.same-as-emergency-contact')"
            :initialValue="form.address.tutors.first.sameAsEmergencyContact.value"
            :options="[
              { label: 'Sí', value: 'si' },
              { label: 'No', value: 'no' }
            ]"
            @handle-change="handleEmergencyContactSelection"
          ></floating-radio-button>
            <!-- TUTOR 1-->
            <p class="font-semibold text-sm">{{ $trans.get("registration.tutor-1") }}</p>
            <div v-if="form.address.tutors.first.sameAsEmergencyContact.value != 'si'" class="grid md:grid-cols-2 gap-4 mt-6">
              <div class="md:col-span-2">
                <floating-input
                  name="tutor1name"
                  :placeholder="$trans.get('registration.tutor1name')"
                  v-model="form.address.tutors.first.basic.tutor1name.value"
                  :initialValue="form.address.tutors.first.basic.tutor1name.value"
                  type="text"
                ></floating-input>
              </div>
              <floating-input
                name="tutor1phone"
                :placeholder="$trans.get('registration.tutor1phone')"
                v-model="form.address.tutors.first.basic.tutor1phone.value"
                :initialValue="form.address.tutors.first.basic.tutor1phone.value"
                type="text"
              ></floating-input>
              <floating-input
                name="tutor1email"
                :placeholder="$trans.get('registration.tutor1email')"
                v-model="form.address.tutors.first.basic.tutor1email.value"
                :initialValue="form.address.tutors.first.basic.tutor1email.value"
                type="email"
              ></floating-input>
            </div>
            <div class="flex justify-center items-center gap-5 mt-6">
                <floating-select-input
                  class="sm:w-1/4 w-full"
                  name="tutor1typeId"
                  :title="$trans.get('registration.type-id-title-optional')"
                  :initialValue="form.address.tutor1typeId.value"
                  :options="[
                    { label: 'DNI', value: 'dni' },
                    { label: 'NIE', value: 'nie' },
                    { label: $trans.get('registration.passport'), value: 'passport' }
                  ]"
                  @handle-change="handleAddress"
                />

                <floating-input
                  name="tutor1numId"
                  :placeholder="$trans.get('registration.tutor2numId')"
                  v-model="form.address.tutors.first.extra.tutor1numId.value"
                  :initialValue="form.address.tutors.first.extra.tutor1numId.value"
                  type="text"
                />
              </div>
          <!-- Archivos DNI Tutor 1 -->
          <div class="w-full">
            <p class="mt-6 mb-3 text-sm">{{ $trans.get('registration.idFiles') }}</p>

            <label class="addFile addFilePersonal text-sm" for="tutor1DniFiles"
              v-if="form.address.tutor1DniFiles.display || form.address.tutor1DniFiles.value.length > 0"
              v-html="placeholderFileText"></label>

            <input
              name="tutor1DniFiles"
              @change="addFilesTutors"
              :initialValue="form.address.tutor1DniFiles.value"
              class="hidden"
              type="file"
              id="tutor1DniFiles"
            />

            <!-- Mostrar archivos subidos -->
            <div v-for="(val, index) in form.address.tutor1DniFiles.value" :key="val.id">
              <progress-file-upload
                name="tutor1DniFiles"
                :index="index"
                v-on:click="delFilesTutors"
                :initialValue="form.address.tutor1DniFiles"
                v-if="!form.address.tutor1DniFiles.display"
              ></progress-file-upload>
            </div>


            <!-- Archivos cargados previamente -->
            <ul class="list-disc list-inside mt-4">
              <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                  v-if="form.address.tutor1DniFilesF.value !== '0' && form.address.tutor1DniFiles.display">
                {{ form.address.tutor1DniFilesF.value }}
                <button @click="deleteFileTutors('tutor1DniFilesF')" class="ml-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                          <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                          <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                      </g>
                  </svg>
                </button>
              </li>
              <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                  v-if="form.address.tutor1DniFilesB.value !== '0' && form.address.tutor1DniFiles.display">
                {{ form.address.tutor1DniFilesB.value }}
                <button @click="deleteFileTutors('tutor1DniFilesB')" class="ml-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                          <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                          <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                      </g>
                  </svg>
                </button>
              </li>
            </ul>
          </div>

            <floating-radio-button
              class="my-6"
              name="addSecondTutor"
              :title="$trans.get('registration.add-second-tutor')"
              :initialValue="form.address.tutors.second.showSecondTutor.value"
              :options="[
                { label: 'Sí', value: 'si' },
                { label: 'No', value: 'no' }
              ]"
              @handle-change="handleSecondTutorSelection"
            ></floating-radio-button>

           <!-- TUTOR 2 -->
            <div v-show="form.address.tutors.second.showSecondTutor.value === 'si'">
              <p class="font-semibold mt-12 text-sm">{{ $trans.get("registration.tutor-2") }}</p>

              <div class="grid md:grid-cols-2 gap-4 mt-6">
                <div class="md:col-span-2">
                  <floating-input
                    name="tutor2name"
                    :placeholder="$trans.get('registration.tutor2name')"
                    v-model="form.address.tutors.second.basic.tutor2name.value"
                    :initialValue="form.address.tutors.second.basic.tutor2name.value"
                    type="text"
                  />
                </div>
                <floating-input
                  name="tutor2phone"
                  :placeholder="$trans.get('registration.tutor2phone')"
                  v-model="form.address.tutors.second.basic.tutor2phone.value"
                  :initialValue="form.address.tutors.second.basic.tutor2phone.value"
                  type="text"
                />
                <floating-input
                  name="tutor2email"
                  :placeholder="$trans.get('registration.tutor2email')"
                  v-model="form.address.tutors.second.basic.tutor2email.value"
                  :initialValue="form.address.tutors.second.basic.tutor2email.value"
                  type="email"
                />
              </div>

              <!-- Tipo de Documento del Tutor 2 -->
              <div class="flex justify-center items-center gap-5 mt-6">
                <floating-select-input
                  class="sm:w-1/4 w-full"
                  name="tutor2typeId"
                  :title="$trans.get('registration.type-id-title-optional')"
                  :initialValue="form.address.tutor2typeId.value"
                  :options="[
                    { label: 'DNI', value: 'dni' },
                    { label: 'NIE', value: 'nie' },
                    { label: $trans.get('registration.passport'), value: 'passport' }
                  ]"
                  @handle-change="handleAddress"
                />

                <floating-input
                  name="tutor2numId"
                  :placeholder="$trans.get('registration.tutor2numId')"
                  v-model="form.address.tutors.second.extra.tutor2numId.value"
                  :initialValue="form.address.tutors.second.extra.tutor2numId.value"
                  type="text"
                />
              </div>
              <!-- Archivos DNI Tutor 2 -->
              <div class="w-full" v-show="form.address.tutors.second.showSecondTutor.value === 'si'">
                <p class="mt-6 mb-3 text-sm">{{ $trans.get('registration.idFiles') }}</p>

                <label class="addFile addFilePersonal text-sm" for="tutor2DniFiles"
                  v-if="form.address.tutor2DniFiles.display || form.address.tutor2DniFiles.value.length > 0"
                  v-html="placeholderFileText"></label>

                <input
                  name="tutor2DniFiles"
                  @change="addFilesTutors"
                  class="hidden"
                  type="file"
                  id="tutor2DniFiles"
                  multiple
                />

                <!-- Mostrar archivos subidos -->
                <div v-for="(val, index) in form.address.tutor2DniFiles.value" :key="val.id">
                  <progress-file-upload
                    name="tutor2DniFiles"
                    :index="index"
                    v-on:click="delFilesTutors"
                    :initialValue="form.address.tutor2DniFiles"
                    v-if="!form.address.tutor2DniFiles.display"
                  ></progress-file-upload>
                </div>
                  <!-- Archivos cargados previamente -->
                <ul class="list-disc list-inside mt-4">
                  <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                      v-if="form.address.tutor2DniFilesF.value !== '0' && form.address.tutor2DniFiles.display">
                    {{ form.address.tutor2DniFilesF.value }}
                    <button @click="deleteFileTutors('tutor2DniFilesF')" class="ml-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                              <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                              <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                          </g>
                      </svg>
                    </button>
                  </li>
                  <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center"
                      v-if="form.address.tutor2DniFilesB.value !== '0' && form.address.tutor2DniFiles.display">
                    {{ form.address.tutor2DniFilesB.value }}
                    <button @click="deleteFileTutors('tutor2DniFilesB')" class="ml-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                              <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                              <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                          </g>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    personal: {
      type: Object,
      required: false,
    },
    address: {
      type: Object,
      required: false,
    },
    blanks: {
    type: Number,
    required: false,
    default: 0
  }

  },
  data: () => {
    return {
      form: {
        personal: {
          basic: {
            name: {
              name: "name",
              value: "",
              errors: [],
            },
            email: {
              name: "email",
              value: "",
              errors: [],
            },
            phone: {
              name: "phone",
              value: "",
              errors: [],
            },
          },
          typeId: {
            name: "typeId",
            value: "dni",
            errors: [],
          },
          numId: {
            name: "numId",
            value: "",
            errors: [],
          },
          idFiles: {
            name: "idFiles",
            value: [],
            display: true,
            maxSize: 2,
            errors: [],
          },
          idFilesF: {
            name: "idFilesF",
            value: [],
            errors: [],
          },
          idFilesB: {
            name: "idFilesB",
            value: [],
            errors: [],
          },
          gender: {
            name: "gender",
            value: "",
            errors: [],
          },
          extra: {
            dateBirth: {
              name: "dateBirth",
              value: "",
              errors: [],
            },
            healthCard: {
              name: "healthCard",
              value: "",
              errors: [],
            },
            nationality: {
              name: "nationality",
              value: "",
              errors: [],
            },
          },
          socialNum: {
            name: "socialNum",
            value: "",
            errors: [],
          },
          foreignCity: {
            name: "foreignCity",
            value: "",
            errors: [],
          },
          foreignProvince: {
            name: "foreignProvince",
            value: "",
            errors: [],
          },
          foreignCountry: {
            name: "foreignCountry",
            value: "",
            errors: [],
          },
          healthCardFiles:{
            name: "healthCardFiles",
            value: [],
            display: true,
            maxSize: 2,
            errors: [],
          },
          healthCardFilesF:{
            name: "healthCardFilesF",
            value: [],
            errors: [],
          },
          healthCardFilesB:{
            name: "healthCardFilesB",
            value: [],
            errors: [],
          },
          photoCardFile:{
            name: "photoCardFile",
            value: [],
            display: true,
            maxSize: 1,
            errors: [],
          },
          language: {
            name: "language",
            value: "",
            errors: [],
          },
          scholarship: {
            name: "scholarship",
            value: "",
            errors: [],
          },
          allergy: {
            name: "allergy",
            value: "",
            errors: [],
          },
          allergyText: {
            name: "allergyText",
            value: "",
            errors: [],
          },
          emergencyContact: {
            name: {
              name: "name",
              value: "",
              errors: [],
            },
            email: {
              name: "email",
              value: "",
              errors: [],
            },
            phone: {
              name: "phone",
              value: "",
              errors: [],
            },
          },

        },
        address: {
            tutor1typeId: {
            name: "typeId",
            value: "dni",
            errors: [],
          },
          tutor2typeId: {
            name: "typeId",
            value: "dni",
            errors: [],
          },
          tutor1DniFiles: {
            name: "tutor1DniFiles",
            value: [],
            display: true,
            maxSize: 2,
            errors: [],
          },
          tutor1DniFilesF: {
              name: "tutor1DniFilesF",
              value: [],
              errors: [],
          },
          tutor1DniFilesB: {
              name: "tutor1DniFilesB",
              value: [],
              errors: [],
          },
          tutor2DniFiles: {
            name: "tutor2DniFiles",
            value: [],
            display: true,
            maxSize: 2,
            errors: [],
          },
          tutor2DniFilesF: {
              name: "tutor2DniFilesF",
              value: [],
              errors: [],
          },
          tutor2DniFilesB: {
              name: "tutor2DniFilesB",
              value: [],
              errors: [],
          },
          tutors: {
            first: {
                sameAsEmergencyContact: {
                  name: "sameAsEmergencyContact",
                  value: "",
                  errors: [],
                },
              basic: {
                tutor1name: {
                  name: "tutor1name",
                  value: "",
                  errors: [],
                },
                tutor1email: {
                  name: "tutor1email",
                  value: "",
                  errors: [],
                },
                tutor1phone: {
                  name: "tutor1phone",
                  value: "",
                  errors: [],
                },
              },
              extra: {
                tutor1numId: {
                  name: "tutor1numId",
                  value: "",
                  errors: [],
                },
              },
            },
            second: {
                showSecondTutor: {
                  name: "showSecondTutor",
                  value: "",
                  errors: [],
                },
              basic: {
                tutor2name: {
                  name: "tutor2name",
                  value: "",
                  errors: [],
                },
                tutor2email: {
                  name: "tutor2email",
                  value: "",
                  errors: [],
                },
                tutor2phone: {
                  name: "tutor2phone",
                  value: "",
                  errors: [],
                },
              },
              extra: {
                tutor2numId: {
                  name: "tutor2numId",
                  value: "",
                  errors: [],
                },
              },
            },
          },
        }
      },
      emergencyContactSameAsTutor:"",
      showSecondTutor: false,
      showTutorsSection: false,
      formSubmitted: false,
    };
  },
  computed: {
    placeholderFileText(){
        if(window.innerWidth < 768){
            return this.$trans.get("registration.addFilePlaceholderMobile");
        }else{
            return this.$trans.get("registration.addFilePlaceholder");
        }
    }
  },
  methods: {
    removeError(event) {
      event.target.classList.remove("border-red-500");
    },
    deleteFileTutors(fileType) {
      this.form.address[fileType].value = '0';
    },
    deleteFile(fileType) {
      this.form.personal[fileType].value = '0';
    },
    handleAddressFirstBasic({ value, name }) {
      this.form.address.tutors.first.basic[name].value = value;
    },
    handleAddressSecondBasic({ value, name }) {
      this.form.address.tutors.second.basic[name].value = value;
    },
    handleAddressFirstExtra({ value, name }) {
      this.form.address.tutors.first.extra[name].value = value;
    },
    handleAddressSecondExtra({ value, name }) {
      this.form.address.tutors.second.extra[name].value = value;
    },
    handleAddress({ value, name }) {
      this.form.address[name].value = value;
    },
    handlePersonalBasic({ value, name }) {
      this.form.personal.basic[name].value = value;
    },
    handlePersonal({ value, name }) {
      this.form.personal[name].value = value;
      if (name === "allergy" && value !== "si") {
      this.form.personal.allergyText.value = "";
    }
    },
    handlePersonalExtra({ value, name }) {
      this.form.personal.extra[name].value = value;
      if (name === "dateBirth") {
        this.checkAge(value);
      }
    },
    handlePersonalEmergencyContact({ value, name }) {
      this.form.personal.emergencyContact[name].value = value;
    },
    handleSecondTutorSelection({ value }) {
      this.form.address.tutors.second.showSecondTutor.value = value;
    //   if(value === 'si'){
    //     this.$nextTick(() => {
    //         this.createDropZonePersonal();
    //     });
    //   }
    },
    handleEmergencyContactSelection({ value }) {
      this.form.address.tutors.first.sameAsEmergencyContact.value = value;

      if (value === "si") {
        this.$set(this.form.address.tutors.first.basic.tutor1name, 'value', this.form.personal.emergencyContact.name.value);
        this.$set(this.form.address.tutors.first.basic.tutor1phone, 'value', this.form.personal.emergencyContact.phone.value);
        this.$set(this.form.address.tutors.first.basic.tutor1email, 'value', this.form.personal.emergencyContact.email.value);
      } else {
        this.$set(this.form.address.tutors.first.basic.tutor1name, 'value', '');
        this.$set(this.form.address.tutors.first.basic.tutor1phone, 'value', '');
        this.$set(this.form.address.tutors.first.basic.tutor1email, 'value', '');
      }
      this.$forceUpdate();
    },


    addFiles(value){
      let name = value.target.id;
      console.log(name);
      
      let arr = [];
      if(this.form.personal[name].value !== undefined && typeof this.form.personal[name].value === 'object'){
        arr = this.form.personal[name].value;
      }

      arr.push(value.target.files[0]);

      this.form.personal[name].display = false;
      this.form.personal[name].value = arr;

      let label = document.querySelector(`label[for="idFiles"]`);
      if (label) {
        label.classList.remove("border-red-500");
      }

      let labelPhoto = document.querySelector(`label[for="photoCardFile"]`);
      if (labelPhoto) {
        label.classList.remove("border-red-500");
      }
    },
    addFilesTutors(value){
      let name = value.target.id;
      let arr = [];

      if(this.form.address[name]?.value !== undefined && typeof this.form.address[name].value === 'object'){
        arr = this.form.address[name].value;
      }

      arr.push(value.target.files[0]);
      this.form.address[name].display = false;
      this.form.address[name].value = arr;
    },

    delFiles(name, index){

      this.form.personal[name].value.splice(index, 1);
      if(this.form.personal[name].value.length > 0){
        var input = {
          name: name,
          value: this.form.personal[name].value,
          display: false,
          maxSize: this.form.personal[name].maxSize,
          errors: [],
        }
      }else{
        var input = {
          name: name,
          value: undefined,
          display: true,
          maxSize: this.form.personal[name].maxSize,
          errors: [],
        }
      }

      this.form.personal[name] = input;
    },
    delFilesTutors(name, index){
      this.form.address[name].value.splice(index, 1);
      if(this.form.address[name].value.length > 0){
        var input = {
          name: name,
          value: this.form.address[name].value,
          display: false,
          maxSize: this.form.address[name].maxSize,
          errors: [],
        }
      }else{
        var input = {
          name: name,
          value: undefined,
          display: true,
          maxSize: this.form.address[name].maxSize,
          errors: [],
        }
      }

      this.form.address[name] = input;
    },
    createDropZonePersonal(){
      window.addEventListener("dragover", (e) => {
        e.preventDefault();
      }, false);
      window.addEventListener("drop", (e) => {
        e.preventDefault();
      }, false);

      let addFiles = document.getElementsByClassName('addFilePersonal');
      for (let n=0; n < addFiles.length; n++) {
        let tmp = addFiles[n];
        tmp.addEventListener('drop', (e) => {
          e.preventDefault();
          // Cogemos el fichero y lo colocamos como valor del input:file
          let tmpFile = e.dataTransfer.files[0];
          let tmpId = e.target.control.id;

          this.addDropFilePersonal(tmpId, tmpFile);
          this.addDropFileTutors(tmpId, tmpFile);
        });
      }
    },
    addDropFilePersonal(name, value){
      // Funcion replica del addFile pero en caso de recibir el documento mediante Drop
      let arr = [];
      try {
          if(this.form.personal[name].value !== undefined && typeof this.form.personal[name].value === 'object'){
            arr = this.form.personal[name].value;
          }
          arr.push(value);
          this.form.personal[name].display = false;
          this.form.personal[name].value = arr;
      } catch (error) {
          console.error(error);
      }
    },
    addDropFileTutors(name, value){
        let arr = [];
        try {
            if(this.form.address[name]?.value !== undefined && typeof this.form.address[name].value === 'object'){
                arr = this.form.address[name].value;
            }
            arr.push(value);
            this.form.address[name].display = false;
            this.form.address[name].value = arr;
        } catch (error) {
            console.error(error);
        }
    },
    checkAge(dateBirth) {
      if (!dateBirth) return;

      const birthDate = new Date(dateBirth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();

      if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      this.age = age;
      this.showTutorsSection = age < 18;

      this.$emit("update-age", age);
    //   this.$nextTick(() => {
    //       this.createDropZonePersonal();
    //   })
    },
  },
  created() {
    if (!this.personal) return;
    const array = this.form.personal;

    //basic
    for (var item in array.basic) {
      if (array.basic.hasOwnProperty(item)) {
        this.form.personal.basic[item].value = this.personal[item];
      }
    }
    //typeId
    this.form.personal.typeId.value = this.personal.typeId || 'dni';
    //numId
    this.form.personal.numId.value = this.personal.numId;
    //idFiles
    this.form.personal.idFiles.value = this.personal.idFiles;
    this.form.personal.idFilesF.value = this.personal.idFilesF;
    this.form.personal.idFilesB.value = this.personal.idFilesB;
    console.log(   "dni user:", this.form.personal.idFiles.value = this.personal.idFiles,
    this.form.personal.idFilesF.value = this.personal.idFilesF,
    this.form.personal.idFilesB.value = this.personal.idFilesB);

    //gender
    this.form.personal.gender.value = this.personal.gender || 'Selecciona';

    //extra
    for (var item in array.extra) {
      if (array.extra.hasOwnProperty(item)) {
        this.form.personal.extra[item].value = this.personal[item];
      }
    }

    this.form.personal.socialNum.value = this.personal.socialNum;

    //healthCardFiles
    this.form.personal.healthCardFiles.value = this.personal.healthCardFiles;
    this.form.personal.healthCardFilesF.value = this.personal.healthCardFilesF;
    this.form.personal.healthCardFilesB.value = this.personal.healthCardFilesB;
    //photoCardFile
    this.form.personal.photoCardFile.value = this.personal.photoCardFile;
    //language
    this.form.personal.language.value = this.personal.language;
    //scholarhsip
    this.form.personal.scholarship.value = this.personal.scholarship || 'no';
    //allergy
    this.form.personal.allergy.value = this.personal.allergy || 'no';
    //allergyText
    this.form.personal.allergyText.value = this.personal.allergyText;
    console.log("dni tutor1:", this.form.address.tutor1DniFiles.value, this.form.address.tutor1DniFilesF.value, this.form.address.tutor1DniFilesB.value);


    if(this.address){

        //tutor1typeId
        this.form.address.tutor1typeId.value = this.address.tutor1typeId || 'dni';
        //tutor2typeId
        this.form.address.tutor2typeId.value = this.address.tutor2typeId || 'dni';

        this.form.address.tutor1DniFiles.value = this.address.tutor1DniFiles?.length ? this.address.tutor1DniFiles : "0";
        this.form.address.tutor2DniFiles.value = this.address.tutor2DniFiles?.length ? this.address.tutor2DniFiles : "0";



        // this.form.address.tutor1DniFiles.value = this.address.tutor1DniFiles;
        this.form.address.tutor1DniFilesF.value = this.address.tutor1DniFilesF || "0";
        this.form.address.tutor1DniFilesB.value = this.address.tutor1DniFilesB || "0";

        // this.form.address.tutor2DniFiles.value = this.address.tutor2DniFiles;
        this.form.address.tutor2DniFilesF.value = this.address.tutor2DniFilesF || "0";
        this.form.address.tutor2DniFilesB.value = this.address.tutor2DniFilesB || "0";

        console.log("dni tutor1:", this.form.address.tutor1DniFiles.value, this.form.address.tutor1DniFilesF.value, this.form.address.tutor1DniFilesB.value);



        //tutor1
        this.form.address.tutors.first.sameAsEmergencyContact.value = this.address.tutor_1_same_as_emergency || 'no';
        //basic
        const arrayAddress = this.form.address;
        for (const item in arrayAddress.tutors.first.basic) {
          if (arrayAddress.tutors.first.basic.hasOwnProperty(item)) {
            console.log(item, this.address[item]);

            this.form.address.tutors.first.basic[item].value = this.address[item];
          }
        }
        //extra
        for (const item in arrayAddress.tutors.first.extra) {
          if (arrayAddress.tutors.first.extra.hasOwnProperty(item)) {
            console.log(item, this.address[item]);

            this.form.address.tutors.first.extra[item].value = this.address[item];
          }
        }

        console.log("numId setted:", this.form.address.tutors.first.extra.tutor1numId.value);

        //tutor2
        this.form.address.tutors.second.showSecondTutor.value = this.address.tutor_2_info;
        //basic
        for (const item in arrayAddress.tutors.second.basic) {
          if (arrayAddress.tutors.second.basic.hasOwnProperty(item)) {
            this.form.address.tutors.second.basic[item].value = this.address[item];
          }
        }
        //extra
        for (const item in arrayAddress.tutors.second.extra) {
          if (arrayAddress.tutors.second.extra.hasOwnProperty(item)) {
            this.form.address.tutors.second.extra[item].value = this.address[item];
          }
        }

    }else{
         this.form.address.tutor1DniFilesF.value =  "0";
        this.form.address.tutor1DniFilesB.value =  "0";
        this.form.address.tutor2DniFilesF.value = "0";
        this.form.address.tutor2DniFilesB.value = "0";
    }

    this.checkAge(this.form.personal.extra.dateBirth.value);

    //Emergency Contact
    this.form.personal.emergencyContact.name.value = this.personal.emergency_name;
    this.form.personal.emergencyContact.email.value = this.personal.emergency_email;
    this.form.personal.emergencyContact.phone.value = this.personal.emergency_phone;

    //Foreign Student
    this.form.personal.foreignCity.value = this.personal.foreignCity;
    this.form.personal.foreignProvince.value = this.personal.foreignProvince;
    this.form.personal.foreignCountry.value = this.personal.foreignCountry;

  },
  mounted(){
    this.createDropZonePersonal();
  },
};
</script>

<style lang="scss" scoped>
  input[type="file"].border-red-500 {
    outline: 2px solid red;
    outline-offset: 2px;
}

</style>
